import { EventCategoryEnum } from "@/v2/enum/events";
import {
  analyticsEventCommonData,
  ITrackEvent,
  trackEvent,
} from "@/v2/util/analytics/trackEvent";

interface IBusinessSettingsTrack {
  businessId: string;
}

export function businessSettingsTrack({
  analytics,
  eventName,
  businessId,
  additionalData = {},
}: ITrackEvent & IBusinessSettingsTrack): void {
  trackEvent({
    eventCategory: EventCategoryEnum.BUSINESS_SETTINGS,
    analytics,
    eventName,
    additionalData: {
      ...analyticsEventCommonData([["business", businessId]]),
      ...additionalData,
    },
  });
}
